import CustomTableCell from './CustomTableCell.component';

export default CustomTableCell;
